<template>
  <el-dialog
    :visible="visible"
    :title="$t('CargoMsg.Cargo_RoleGroupManagement')"
    width="80%"
    height="800px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="role-group-container">
      <div class="left-panel">
        <div class="panel-header">
          <div class="button-group">
            <el-button type="primary" size="mini" @click="addRoleGroup">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button type="danger" size="mini" @click="deleteRoleGroups">
              {{ $t('CargoMsg.Cargo_Delete') }}
            </el-button>
          </div>
        </div>
        <cargo-ag-grid
          :show-side-bar="false"
          :column-defs="left.columnDefs"
          :row-data="left.rowData"
          :grid-options="left.gridOptions"
          style="width: 100%; height: 680px"
          @gridReady="params=>{leftGridApi=params.api}"
        />
      </div>
      <div class="right-panel">
        <div class="panel-header">
          <span>{{ $t('CargoMsg.Cargo_ApplicationPermission') }}</span>
        </div>
        <cargo-ag-grid
          :show-side-bar="false"
          :column-defs="officeDeptTree.columnDefs"
          :row-data="officeDeptTree.rowData"
          :grid-options="officeDeptTree.gridOptions"
          style="width: 100%; height: 680px"
          @gridReady="params=>{rightGridApi=params.api}"
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { getUserGroupsFunc } from '@/api/userGroup'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { getOfficeDeptTree } from '@/api/office'

export default {
  name: 'RoleGroupDialog',
  components: {
    cargoAgGrid
  },
  props: {
    visible: { type: Boolean, default: false },
    userGroups: { type: Array, default: () => [] },
    currentRoles: { type: Array, default: () => [] },
    userId: { type: Number, default: 0 }
  },
  data() {
    return {
      leftGridApi: null,
      rightGridApi: null,
      left: {
        rowData: [],
        columnDefs: [
          {
            headerName: '',
            width: 55,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RoleGroupName'),
            field: 'groupName',
            editable: true,
            cellEditor: 'CargoAgGridCommonInputEditor',
            minWidth: 500
          }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor
          },
          onRowClicked: this.handleLeftRowClick
        }
      },
      officeDeptTree: {
        columnDefs: [
          {
            headerName: 'Path',
            field: 'path',
            width: 500,
            hide: true
          }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            width: 550,
            tooltipValueGetter: (params) => {
              return ''
            },
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                if (params.data.type === 1) {
                  return '[' + params.data.code + ']' + params.data.chineseName
                }
                if (params.data.type === 3) {
                  const iconName = params.data.checked ? 'checkbox-checked-edit' : 'checkbox-notChecked-edit'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:15px;width:15px;vertical-align:text-bottom;">
              <use xlink:href="#icon-${iconName}"></use></svg>${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              params.data.checked = !params.data.checked
              // 获取当前选中的左侧行
              for (const item of this.left.rowData) {
                if (item.groupName === this.selectedData.groupName) {
                  // 获取右侧树形结构中所有选中的权限
                  const selectedPermissions = this.officeDeptTree.rowData.filter(p => p.checked && p.typeDesc === 'role')
                  item.userGroupRoles = [...selectedPermissions]
                }
              }
              params.api.refreshCells({ force: true })
              // 更新 rowData 以确保数据同步
              this.left.rowData = [...this.left.rowData]
              this.leftGridApi.setRowData(this.left.rowData)
            }
          },
          onRowDataChanged: event => {
            event.api.clearFocusedCell()
            setTimeout(() => {
              const nodes = this.rightGridApi.rowModel.rootNode.allLeafChildren
              for (const p of nodes) {
                if (p.data.checked) {
                  this.expandedNode(p)
                }
              }
              this.rightGridApi.onGroupExpandedOrCollapsed()
            }, 100)
          },
          getRowClass: (params) => {
            if (!params.node.group && params.data.isMaster) {
              return 'is-master'
            }
          },
          onRowClicked: {}
        },
        rowData: []
      },
      userGroup: {
        groupName: '',
        userId: 0,
        description: '',
        userGroupRoles: []
      },
      selectGroupRoleMap: null,
      selectedData: null
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        if (newVal) {
          await this.fetchOfficeDeptTree()
          await this.loadData()
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadData() {
      try {
        // 加载左侧角色组列表
        // const resp = await getUserGroupsFunc({ userId: this.userId })
        this.left.rowData = this.userGroups || []

        // 确保网格已准备好后再选中第一行
        if (this.leftGridApi && this.left.rowData.length > 0) {
          // 延迟执行，确保网格渲染完成
          setTimeout(() => {
            this.leftGridApi.clearFocusedCell()
            const nodes = this.leftGridApi.getModel().rowsToDisplay
            if (nodes && nodes.length > 0) {
              const curNode = nodes[0]
              curNode.setSelected(true)
              this.leftGridApi.refreshCells({ force: true })
              this.handleLeftRowClick({ data: curNode.data })
            }
          }, 200)
        }
      } catch (error) {
        this.$message.error(this.$t('SystemMaintenance.LoadFailed'))
      }
    },
    expandedNode(expandedNode) {
      if (expandedNode) {
        expandedNode.expanded = true
        if (expandedNode.parent) {
          this.expandedNode(expandedNode.parent)
        }
      }
    },
    async fetchOfficeDeptTree() {
      this.loading = true
      await getOfficeDeptTree().then(res => {
        this.officeDeptTree.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    async handleLeftRowClick(event) {
      if (!event || !event.data) return
      this.selectedData = null
      await this.lookData(event.data)
    },
    async lookData(data) {
      this.selectedData = data
      const userGroupRoleMap = new Map()
      if (data.userGroupRoles) {
        for (const item of data.userGroupRoles) {
          userGroupRoleMap.set(item.uuid, true)
        }
        this.selectGroupRoleMap = userGroupRoleMap
      } else {
        this.selectGroupRoleMap = null
      }
      for (const item of this.officeDeptTree.rowData) {
        item.checked = false
        if (this.selectGroupRoleMap) {
          if (item.type === 3 && this.selectGroupRoleMap && this.selectGroupRoleMap.get(item.uuid)) {
            item.checked = true
          }
        }
      }
      this.officeDeptTree.rowData = [...this.officeDeptTree.rowData]
      this.leftGridApi.deselectAll()
    },
    addRoleGroup() {
      // 计算下一个字母后缀
      const nextLetterIndex = this.left.rowData.length
      const letterSuffix = String.fromCharCode(65 + nextLetterIndex)
      const defaultName = this.$t('CargoMsg.Cargo_RoleGroup') + letterSuffix
      const newGroup = { groupName: defaultName, userId: this.userId, description: '', userGroupRoles: [] }
      // 如果是第一个新增的角色组，复制当前账号的角色
      if (this.left.rowData.length === 0 && this.currentRoles) {
        newGroup.userGroupRoles = [...this.currentRoles]
      }

      this.left.rowData.push(newGroup)
      if (this.leftGridApi) {
        this.leftGridApi.setRowData(this.left.rowData)
      }
    },
    deleteRoleGroups() {
      const selectedRows = this.leftGridApi.getSelectedRows()
      if (!selectedRows.length) {
        return
      }
      for (const row of selectedRows) {
        const index = this.left.rowData.findIndex(p => p === row)
        if (index > -1) {
          this.left.rowData.splice(index, 1)
        }
      }
    },
    async handleConfirm() {
      const nameMap = new Map()
      for (const item of this.left.rowData) {
        if (!item.groupName) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NameCanTBeEmpty'))
          return
        } else {
          if (nameMap.has(item.groupName)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_RepeatedMaintenance'))
            return
          }
          nameMap.set(item.groupName, true)
        }
        if (!item.userGroupRoles || item.userGroupRoles.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_UnmaintainedRoleGroupPermissions'))
          return
        }
        for (const role of item.userGroupRoles) {
          if (!role.users) {
            role.users = []
          }
        }
      }
      if (this.left.rowData.length === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RoleGroupCountLessThanTwo'))
        return
      }
      this.$emit('callback', this.left.rowData)
      this.handleClose()
    },
    handleClose() {
      this.officeDeptTree.rowData = []
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="scss">
.role-group-container {
  display: flex;
  gap: 20px;

  .left-panel,
  .right-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    height:  680px;

    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      span {
        font-weight: bold;
      }
    }
  }
}
</style>
